export default "__VITE_ASSET__BUZfz_8v__"